const SetCookie = (cookieValue) => {
  document.cookie = cookieValue;
};

export default SetCookie;
